import { Routes } from '@angular/router';

import { DefaultLoaderPageComponent } from '@usheru-hff/hff-common/ui-default-loader';

import { COLLECTIONS_ROUTES } from './collections.routes';
import { PROFILE_ROUTES } from './profile.routes';

export const APP_ROUTES: Routes = [
  ...COLLECTIONS_ROUTES,
  ...PROFILE_ROUTES,
  // MOVIES
  {
    path: 'movies',
    loadChildren: () =>
      import('@usheru-hff/movies-catalogue/feature-movies-page').then(m => m.MoviesCatalogueFeatureMoviesPageModule)
  },

  {
    path: 'movie-site',
    loadChildren: () =>
      import('@usheru-hff/branded-page/ui-branded-templates').then(m => m.BrandedPageUiBrandedTemplatesModule)
  },
  {
    path: 'movie',
    loadChildren: () =>
      import('@usheru-hff/movie-detail/feature-movie-detail-page').then(m => m.MoviesDetailFeatureMovieDetailPageModule)
  },
  {
    path: 'en-cines',
    loadComponent: () => import('./acontra-en-cines/acontra-en-cines.component').then(a => a.AcontraEnCinesComponent),
    pathMatch: 'full'
  },
  // DEFAULT LOADER
  {
    path: 'default-loader',
    component: DefaultLoaderPageComponent,
    pathMatch: 'full'
  },
  //HOME
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  // NOT-FOUND
  {
    path: 'not-found',
    loadChildren: () => import('@usheru-hff/hff-common/ui-not-found-page').then(m => m.HffCommonUiNotFoundPageModule)
  },
  //CUSTOM PAGE
  {
    path: ':custompage',
    loadComponent: () => import('@usheru-hff/custom-page/feature-custom-page').then(m => m.CustomPageComponent)
  },
  {
    path: '**',
    redirectTo: 'not-found'
  }
];
